import { createRouter, createWebHistory } from "vue-router";
import ClientForm from "../components/ClientForm.vue";
import JamiiCover from "../components/JamiiCover.vue";
import PerPerson from "../components/PerPerson.vue";
import ChildOnly from "../components/ChildOnly.vue";
import ComparisionQuote from "../components/ComparisionQuote.vue";
import AfyaNafuu from "../components/AfyaNafuu.vue";
import FeminaCover from "../components/FeminaCover.vue";

const routes = [
    { path: '/', component: ClientForm },
    { path: '/jamii', component: JamiiCover },
    { path: '/per-person', component: PerPerson },
    { path: '/comparision', component: ComparisionQuote },
    { path: '/afya-nafuu', component: AfyaNafuu },
    { path: '/child-only', component: ChildOnly},
    { path: '/femina', component: FeminaCover}
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;